import React, { useEffect, useRef, useState } from 'react';
import { StormDoorColor } from '../../../../entities-generated/common/storm-door-color';
import { useShowColorPrefsPanel } from '../../../events';
import { BwjSidePanel } from '../../../../framework/components/bwj-side-panel';
import { BwjButtonType } from '../../../../framework/components/bwj-button';
import { any } from '../../../../framework/utils/collection';
import { StormDoorColorSelector } from '../../../components/st-door-color-select';
import { IStormDoorColorOption } from '../../../../entities-generated/common/storm-door-color-option';

interface IStormColorPreferencePanelProps {
  onUpdatePreferences: (prefs: StormDoorColor[]) => void;
}

const selectionHasChanged = (orig: StormDoorColor[], nu: StormDoorColor[]) => {
  if(orig.length !== nu.length) { return true; }
  return any(orig, og => nu.indexOf(og) === -1);
}

const subscriberId = 'Panel.StormColorPreference';

export const StormColorPreferencePanel: React.FunctionComponent<IStormColorPreferencePanelProps> = (props) => {
  const [showPanel, setShowPanel] = useState(false);
  const [colorPreferences, setColorPreferences] = useState<StormDoorColor[]>([]);
  const ogColorPrefs = useRef<StormDoorColor[]>([]);
  const options = useRef<IStormDoorColorOption[]>([]);
  const openEvent = useShowColorPrefsPanel(subscriberId);
  useEffect(() => {
    if(!openEvent || openEvent.inaccessible()) { return; }
    const pc = openEvent.getArgs();
    ogColorPrefs.current = pc.stormDoorColorPreferences;
    options.current = pc.stormDoorColorOptions;
    setColorPreferences(ogColorPrefs.current);
    setShowPanel(true);
  }, [openEvent]);

  const onClosePanel = () => setShowPanel(false);

  const onUpdatePreferences = () => {
    if(selectionHasChanged(ogColorPrefs.current, colorPreferences)) {
      props.onUpdatePreferences(colorPreferences);
    }
    onClosePanel();
  }

  return (
    <BwjSidePanel
      showPanel={showPanel}
      title={'Color Family Preferences'}
      footerButtons={[{
        buttonStyle: BwjButtonType.PrimaryStandard,
        text: 'Update my preferences',
        onClick: onUpdatePreferences,
      }, {
        buttonStyle: BwjButtonType.DefaultStandard,
        text: 'Cancel',
        onClick: onClosePanel,
      }]}
      onDismiss={onClosePanel}
      closeButtonAriaLabel={'Close color family preferences modal'}
    >
      <div style={{padding: '1.5rem' }}>
        <StormDoorColorSelector
          swatchSize={6.5}
          options={options.current}
          selected={colorPreferences}
          showLabels={true}
          onSelectionChanged={setColorPreferences}
        />
      </div>
    </BwjSidePanel>
  );
};